/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p.error[_ngcontent-%COMP%]{font-size:.85rem;text-align:left;margin-top:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-validation-alerts/achoo-validation-alerts.component.scss.shim.ngstyle.js.pre-build-optimizer.js